import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BACKEND}/api`;

export const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("traveloble_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function saveAuth(token, user) {
  localStorage.setItem("traveloble_token", token);
  localStorage.setItem("traveloble_user", JSON.stringify(user));
}

export function getUser() {
  const raw = localStorage.getItem("traveloble_user");
  return raw ? JSON.parse(raw) : null;
}

export function clearAuth() {
  localStorage.removeItem("traveloble_token");
  localStorage.removeItem("traveloble_user");
}
